export default __webpack_public_path__ + "static/servers-3bf9318906273ae17578af528c6addea.png";